<c11n-banner [closeAriaLabel]="'close message'" [hasCloseControl]="false" [headingText]="
        'Your analysis doesn’t include accounts with pending transactions or a $0 balance'
      " [variant]="'warning'">
    <div class="c11n-text-md--crop">
        If you just opened an account, your analysis will update once your funds finish processing.
        To include a $0 balance account, you'll need to add funds to it. You can track all of your
        pending transactions by visiting
        <a class="c11n-link c11n-link--secondary" aria-label="visit order status" href="{{ this.orderStatus }}"
            target="_blank">Order status</a>, then return to this page to review your updated analysis.
    </div>
</c11n-banner>